<div mat-dialog-title class="mat-accent m-0">
  <span i18n class="title dialog-title">Установите типы полуфабрикатов</span>
  <button mat-button class="mat-icon-button" [mat-dialog-close] aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="no-padding">
  <table mat-table #table [dataSource]="data" class="w-full" fusePerfectScrollbar>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef i18n>Название</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="block">
      <th mat-header-cell *matHeaderCellDef><span i18n>Блок</span><br />(<span i18n>Участвует в раскрое</span>)</th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox [ngModel]="!row.readAsAsembly" (ngModelChange)="row.readAsAsembly = !$event"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="assembly">
      <th mat-header-cell *matHeaderCellDef>
        <span i18n>Покупное изделие</span><br />(<span i18n>Не участвует в раскрое</span>)
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox [(ngModel)]="row.readAsAsembly"></mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['name', 'block', 'assembly']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['name', 'block', 'assembly']"></tr>
  </table>
</div>

<div mat-dialog-actions>
  <button i18n mat-raised-button class="mat-accent" [mat-dialog-close]="data">ОК</button>
  <button i18n mat-button [mat-dialog-close]="">ОТМЕНА</button>
</div>
